import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'
import { LayoutAccount } from './components/LayoutAccount/LayoutAccount'
const ProfilePage = lazy(() => import('./pages/ProfilePage'))
const PasswordSecurityPage = lazy(() => import('./pages/PasswordSecurityPage'))
const PushNotificationPage = lazy(() => import('./pages/PushNotification'))
const MyCommissionsPage = lazy(() => import('./pages/myCommissionsPage'))
export const accountRoutes = () => {
  return (
    <>
      <Route element={<LayoutAccount />}>
        <Route path={pageUrl.accountProfile} element={<ProfilePage />} />
        <Route
          path={pageUrl.accountPasswordSecurity}
          element={<PasswordSecurityPage />}
        />
        <Route
          path={pageUrl.pushNotification}
          element={<PushNotificationPage />}
        />
        <Route path={pageUrl.myCommissions} element={<MyCommissionsPage />} />
      </Route>
    </>
  )
}
